const languageRegex = {
  aa: /[^a-zA-Z\s'-]/g, // Afar
  ab: /[^а-яА-ЯӘ-ӨҢң\s'-]/g, // Abkhazian
  ae: /[^a-zA-Z\s'-]/g, // Avestan
  af: /[^a-zA-Z\s'-]/g, // Afrikaans
  ak: /[^ɔƉƏɑƎɛɜɝɞɟɠɡɢɣɤɥɦɧɨɩɪɫɬɭɮɯɰɱɲɳɴɵɶɷɸɹɺɻɼɽɾɿʀ\s'-]/g, // Akan
  am: /[^\u1200-\u137F\s'-]/g, // Amharic
  an: /[^a-zA-ZáÁéÉíÍñÑóÓúÚüÜ\s'-]/g, // Aragonese
  ar: /[^a-zA-Z\s'-]/g, // Arabic
  as: /[^\u0980-\u09FF\s'-]/g, // Assamese
  av: /[^а-яА-Я\s'-]/g, // Avaric
  ay: /[^ -~¡-ÿ\s'-]/g, // Aymara
  az: /[^Ç-üĞİı\s'-]/g, // Azerbaijani
  ba: /[^Ҁ-ү\s'-]/g, // Bashkir
  be: /[^а-яА-Я\s'-]/g, // Belarusian
  bg: /[^А-Я\s'-]/g, // Bulgarian
  bh: /[^क-ह़\s'-]/g, // Bihari
  bi: /[^ -~¡-ÿ\s'-]/g, // Bislama
  bm: /[^ -~¡-ÿ\s'-]/g, // Bambara
  bn: /[^\u0980-\u09FF\s'-]/g, // Bengali
  bo: /[^\u0F00-\u0FFF\s'-]/g, // Tibetan
  br: /[^a-zA-ZàÀâÂçÇéÉèÈêÊëËîÎïÏôÔûÛüÜ\s'-]/g, // Breton
  bs: /[^ -~¡-ÿ\s'-]/g, // Bosnian
  ca: /[^a-zA-ZàÀèÈéÉíÍïÏòÒóÓúÚüÜçÇ\s'-]/g, // Catalan
  ce: /[^а-яА-Я\s'-]/g, // Chechen
  ch: /[^ -~¡-ÿ\s'-]/g, // Chamorro
  cmn_hans: /[^一-龿㐀-䶵\s'-]/g, // Mandarin (Simplified)
  cmn_hant: /[^一-龿㐀-䶵\s'-]/g, // Mandarin (Traditional)
  co: /[^ -~¡-ÿ\s'-]/g, // Corsican
  cr: /[^\u1400-\u167F\s'-]/g, // Cree
  cs: /[^Ā-ſ\s'-]/g, // Czech
  cu: /[^а-яА-Я\s'-]/g, // Church Slavic
  cv: /[^а-яА-Я\s'-]/g, // Chuvash
  cy: /[^ -~¡-ÿ\s'-]/g, // Welsh
  da: /[^a-zA-ZÆæØøÅå\s'-]/g, // Danish
  de: /[^a-zA-ZäÄöÖüÜß\s'-]/g, // German
  dv: /[^\u0780-\u07FF\s'-]/g, // Divehi
  dz: /[^\u0F00-\u0FFF\s'-]/g, // Dzongkha
  ee: /[^ƀ-ɏ\s'-]/g, // Ewe
  el: /[^ΐ-Ͽ\s'-]/g, // Greek
  en: /[^a-zA-Z\s'-]/g, // English
  eo: /[^Ā-ſ\s'-]/g, // Esperanto
  es: /[^a-zA-ZáÁéÉíÍñÑóÓúÚüÜ\s'-]/g, // Spanish
  es_419: /[^a-zA-ZáÁéÉíÍñÑóÓúÚüÜ\s'-]/g, // Spanish
  et: /[^a-zA-ZäÄõÕöÖüÜšŠžŽ\s'-]/g, // Estonian
  eu: /[^a-zA-ZàÀèÈéÉíÍïÏòÒóÓúÚüÜñÑ\s'-]/g, // Basque
  fa: /[^\u0600-\u06FF\s'-]/g, // Persian
  ff: /[^\u0020-\u007E\u00A1-\u00FF\s'-]/g, // Fulah
  fi: /[^a-zA-ZäÄöÖ\s'-]/g, // Finnish
  fj: /[^a-zA-Z\s'-]/g, // Fijian
  fo: /[^a-zA-ZáÁðÐéÉíÍóÓúÚýÝ\s'-]/g, // Faroese
  fr: /[^a-zA-ZàÀâÂçÇéÉèÈêÊëËîÎïÏôÔûÛüÜ\s'-]/g, // French
  fy: /[^a-zA-ZàÀèÈéÉíÍïÏòÒóÓúÚüÜ\s'-]/g, // Western Frisian
  ga: /[^a-zA-ZáÁéÉíÍóÓúÚ\s'-]/g, // Irish
  gd: /[^àÀèÈìÌòÒùÙ\s'-]/g, // Scottish Gaelic
  gl: /[^a-zA-ZáÁéÉíÍñÑóÓúÚüÜ\s'-]/g, // Galician
  gn: /[^\uA700-\uA71F\s'-]/g, // Guarani
  gu: /[^ઁ-ૠ\s'-]/g, // Gujarati
  gv: /[^a-zA-Z\s'-]/g, // Manx
  ha: /[^a-zA-ZàÀèÈéÉíÍïÏòÒóÓúÚ\s'-]/g, // Hausa
  he: /[^א-ת\s'-]/g, // Hebrew
  hi: /[^ँ-ॣ।\s'-]/g, // Hindi
  ho: /[^a-zA-Z\s'-]/g, // Hiri Motu
  hr: /[^a-zA-ZčČćĆđĐšŠžŽ\s'-]/g, // Croatian
  ht: /[^a-zA-ZàÀèÈéÉíÍïÏòÒóÓúÚ\s'-]/g, // Haitian Creole
  hu: /[^a-zA-ZáÁéÉíÍóÓöÖőŐúÚüÜűŰ\s'-]/g, // Hungarian
  hy: /[^ա-ֆ\s'-]/g, // Armenian
  hz: /[^a-zA-Z\s'-]/g, // Herero
  ia: /[^a-zA-ZàÀèÈéÉíÍïÏòÒóÓúÚüÜ\s'-]/g, // Interlingua
  id: /[^a-zA-ZàÀèÈéÉíÍïÏòÒóÓúÚüÜ\s'-]/g, // Indonesian
  ie: /[^a-zA-ZàÀèÈéÉíÍïÏòÒóÓúÚüÜ\s'-]/g, // Interlingue
  ig: /[^Ịị\s'-]/g, // Igbo
  ii: /[^ꆈ-ꓘ\s'-]/g, // Yi
  ik: /[^a-zA-Z\s'-]/g, // Inupiaq
  io: /[^a-zA-Z\s'-]/g, // Ido
  is: /[^a-zA-ZáÁðÐéÉíÍóÓúÚýÝ\s'-]/g, // Icelandic
  it: /[^a-zA-ZàÀèÈéÉìÌíÍîÎïÏòÒóÓùÙúÚ\s'-]/g, // Italian
  iu: /[^ᐃ-ᑯ\s'-]/g, // Inuktitut
  ja: /[^ぁ-んァ-ン\s'-]/g, // Japanese
  jv: /[^\uA980-\uA9DF\s'-]/g, // Javanese
  ka: /[^ა-ჰ\s'-]/g, // Georgian
  kg: /[^a-zA-Z\s'-]/g, // Kongo
  ki: /[^a-zA-Z\s'-]/g, // Kikuyu
  kj: /[^a-zA-Z\s'-]/g, // Kuanyama
  kk: /[^Ҁ-ү\s'-]/g, // Kazakh
  kl: /[^a-zA-Z\s'-]/g, // Kalaallisut
  km: /[^\u1780-\u17FF\s'-]/g, // Khmer
  kn: /[^ಁ-ೢ\s'-]/g, // Kannada
  ko: /[^가-힣\s'-]/g, // Korean
  kr: /[^가-힣\s'-]/g, // Kanuri
  ks: /[^ا-ی\s'-]/g, // Kashmiri
  ku: /[^ا-ی\s'-]/g, // Kurdish
  kv: /[^а-яА-Я\s'-]/g, // Komi
  kw: /[^a-zA-Z\s'-]/g, // Cornish
  ky: /[^а-яА-Я\s'-]/g, // Kyrgyz
  la: /[^a-zA-Z\s'-]/g, // Latin
  lb: /[^a-zA-ZäÄéÉëËïÏöÖüÜ\s'-]/g, // Luxembourgish
  lg: /[^a-zA-Z\s'-]/g, // Ganda
  li: /[^a-zA-Z\s'-]/g, // Limburgish
  ln: /[^a-zA-ZáÁéÉíÍóÓúÚ\s'-]/g, // Lingala
  lo: /[^ກ-ໝ\s'-]/g, // Lao
  lt: /[^ąčęėįšųūž\s'-]/g, // Lithuanian
  lu: /[^a-zA-Z\s'-]/g, // Luba-Katanga
  lv: /[^āčēģīķļņšūž\s'-]/g, // Latvian
  mg: /[^a-zA-Z\s'-]/g, // Malagasy
  mh: /[^a-zA-Z\s'-]/g, // Marshallese
  mi: /[^āēīōū\s'-]/g, // Māori
  mk: /[^а-џ\s'-]/g, // Macedonian
  ml: /[^ം-ൿ\s'-]/g, // Malayalam
  mn: /[^а-яА-Я\s'-]/g, // Mongolian
  mr: /[^ँ-ॣ\s'-]/g, // Marathi
  ms: /[^a-zA-Z\s'-]/g, // Malay
  mt: /[^a-zA-Z\s'-]/g, // Maltese
  my: /[^က-႟\s'-]/g, // Burmese
  na: /[^a-zA-Z\s'-]/g, // Nauruan
  nb: /[^a-zA-ZæÆøØåÅ\s'-]/g, // Norwegian Bokmål
  nd: /[^a-zA-Z\s'-]/g, // North Ndebele
  ne: /[^ँ-ॣ\s'-]/g, // Nepali
  ng: /[^a-zA-Z\s'-]/g, // Ndonga
  nl: /[^a-zA-Z\s'-]/g, // Dutch
  nn: /[^a-zA-ZæÆøØåÅ\s'-]/g, // Norwegian Nynorsk
  no: /[^a-zA-ZæÆøØåÅ\s'-]/g, // Norwegian
  nr: /[^a-zA-Z\s'-]/g, // South Ndebele
  nv: /[^a-zA-Z\s'-]/g, // Navajo
  ny: /[^a-zA-Z\s'-]/g, // Chichewa
  oc: /[^a-zA-ZàÀèÈéÉíÍïÏòÒóÓúÚ\s'-]/g, // Occitan
  oj: /[^a-zA-Z\s'-]/g, // Ojibwe
  om: /[^አ-ፏ\s'-]/g, // Oromo
  or: /[^଀-ୟ\s'-]/g, // Odia
  os: /[^а-яА-Я\s'-]/g, // Ossetic
  pa: /[^ਁ-ੴ\s'-]/g, // Punjabi
  pi: /[^a-zA-Z\s'-]/g, // Pali
  pl: /[^a-zA-Ząćęłńóśźż\s'-]/g, // Polish
  ps: /[^پچحخدذرزژسشصضطظعغفقکلمنوۆهی\s'-]/g, // Pashto
  pt: /[^a-zA-ZàÀâÂãÃáÁéÉêÊíÍóÓôÔõÕúÚ\s'-]/g, // Portuguese
  qu: /[^a-zA-ZáÁéÉíÍñÑóÓúÚ\s'-]/g, // Quechua
  rm: /[^a-zA-Z\s'-]/g, // Romansh
  rn: /[^a-zA-Z\s'-]/g, // Rundi
  ro: /[^a-zA-ZăĂâÂîÎșȘțȚ\s'-]/g, // Romanian
  ru: /[^а-яА-ЯёЁ\s'-]/g, // Russian
  rw: /[^a-zA-Z\s'-]/g, // Kinyarwanda
  sa: /[^ऀ-ॣ\s'-]/g, // Sanskrit
  sc: /[^a-zA-ZàÀèÈéÉíÍïÏòÒóÓúÚ\s'-]/g, // Sardinian
  sd: /[^ء-ۓ\s'-]/g, // Sindhi
  se: /[^a-zA-Z\s'-]/g, // Northern Sami
  sg: /[^a-zA-Z\s'-]/g, // Sango
  si: /[^අ-෴\s'-]/g, // Sinhala
  sk: /[^a-zA-ZáÁäÄčČďĎéÉíÍľĽňŇóÓôÔŕŔšŠťŤúÚýÝžŽ\s'-]/g, // Slovak
  sl: /[^a-zA-ZčČšŠžŽ\s'-]/g, // Slovenian
  sm: /[^a-zA-Z\s'-]/g, // Samoan
  sn: /[^a-zA-Z\s'-]/g, // Shona
  so: /[^a-zA-Z\s'-]/g, // Somali
  sq: /[^a-zA-ZáÁëËçÇéÉíÍóÓúÚ\s'-]/g, // Albanian
  sr: /[^а-яА-Я\s'-]/g, // Serbian
  ss: /[^a-zA-Z\s'-]/g, // Swati
  st: /[^a-zA-Z\s'-]/g, // Southern Sotho
  su: /[^a-zA-Z\s'-]/g, // Sundanese
  sv: /[^a-zA-ZåÅäÄöÖ\s'-]/g, // Swedish
  sw: /[^a-zA-Z\s'-]/g, // Swahili
  ta: /[^ஃ-௺\s'-]/g, // Tamil
  te: /[^ఁ-౯\s'-]/g, // Telugu
  tg: /[^а-яА-Я\s'-]/g, // Tajik
  th: /[^ก-๛\s'-]/g, // Thai
  ti: /[^ሀ-ፏ\s'-]/g, // Tigrinya
  tk: /[^a-zA-Z\s'-]/g, // Turkmen
  tl: /[^a-zA-Z\s'-]/g, // Tagalog
  tn: /[^a-zA-Z\s'-]/g, // Tswana
  to: /[^a-zA-Z\s'-]/g, // Tongan
  tr: /[^a-zA-ZçÇğĞıİöÖşŞüÜ\s'-]/g, // Turkish
  ts: /[^a-zA-Z\s'-]/g, // Tsonga
  tt: /[^а-яА-Я\s'-]/g, // Tatar
  tw: /[^a-zA-Z\s'-]/g, // Twi
  ty: /[^a-zA-Z\s'-]/g, // Tahitian
  ug: /[^ء-ۇ\s'-]/g, // Uyghur
  uk: /[^а-яА-ЯїЇіІєЄ\s'-]/g, // Ukrainian
  ur: /[^ء-ۓ\s'-]/g, // Urdu
  uz: /[^a-zA-Z\s'-]/g, // Uzbek
  ve: /[^a-zA-Z\s'-]/g, // Venda
  vi: /[^a-zA-ZàÀáÁảẢãÃạẠăĂằẰắẮẳẲẵẴạẠâÂầẦấẤẩẨẫẪậẬ\s'-]/g, // Vietnamese
  vo: /[^a-zA-Z\s'-]/g, // Volapük
  wa: /[^a-zA-Z\s'-]/g, // Walloon
  wo: /[^a-zA-Z\s'-]/g, // Wolof
  xh: /[^a-zA-Z\s'-]/g, // Xhosa
  yi: /[^א-ת\s'-]/g, // Yiddish
  yue_hant: /[^a-zA-Z\s'-]/g, // Cantonese (Traditional)
  yo: /[^a-zA-Z\s'-]/g, // Yoruba
  za: /[^a-zA-Z\s'-]/g, // Zhuang
  zh: /[^\u4E00-\u9FFF\s'-]/g, // Chinese
  zu: /[^a-zA-Z\s'-]/g // Zulu
}

export default languageRegex



// WEBPACK FOOTER //
// ./src/data/productlanguagesregex.js